<template>
    <o-form-group :label="label">
        <div class="">
            <b-dropdown id="sort-dropdown" offset="25" :text="displayName" class="select-search w-100">
            <b-dropdown-form>
                <b-form-input v-model="search" :placeholder="$t('core.search')" class="mb-1" v-if="searchable"></b-form-input>
                <input v-model="localValue" type="text" class="localvalue d-none"/>
                <b-dropdown-item-button :title="filter[textField]" aria-describedby="dropdown-header-label" :class="filter.id===localValue ? 'back-orange' :''" v-for="filter in filteredItems" :key="filter.value" @click="filterCheckbox(filter)">
                    {{  filter[textField] }}
                </b-dropdown-item-button>
            </b-dropdown-form>
            </b-dropdown>
        </div>
    </o-form-group>
  </template>
  
  <script>
    import axios from 'axios'
  
    export default {
      name: 'o-value-select-search',
      props: {
        value: {
          default: null
        },
        url: {
          type: String,
          default: ''
        },
        label: {
            type: String
        },
        valueField: {
          type: String,
          default: 'value'
        },
        textField: {
          type: String,
          default: 'text'
        },
        items: {
          default: function () { return [] }
        },
        readonly: {
          type: Boolean,
          default: false
        },
        searchable: {
          type: Boolean,
          default: true
        }
      },
      computed: {
            filteredItems() {
                if(this.search) {
                    return this.selectItems.filter(item => {
                        return item[this.textField].toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    })
                } else {
                    return this.selectItems
                }
            },
            displayName() {
                if(this.localValue) {
                    let item = this.selectItems.filter(item => {
                        return item[this.valueField] === this.localValue
                    });

                    if(item.length) {
                      this.$emit('input-object', item[0])
                      return item[0][this.textField]
                    }
                }
                return ''
            }
        },
      mounted() {
        this.localValue = this.value
      },
  
      watch: {
        value(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.localValue = newVal
          }
        },
        localValue(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.$emit('input', newVal)
            this.$emit('input-object', this.selectItems.find(i => i[this.valueField] == newVal))
          }
        }
      },
  
      created() {
        // no AJAX url specified, use options from property
        if (this.url === '') {
          this.selectItems = this.items
          return
        }
  
        axios
          .get(this.url, {params: {per_page: Number.MAX_SAFE_INTEGER}})
          .then((response) => {
            this.selectItems = response.data.data
          })
          .catch((error) => {
            console.log(error)
            window.alert('could not fetch value list options from ' + this.url)
          })
      },
      methods: {
        filterCheckbox(filter) {
            this.localValue = filter[this.valueField];
            this.$emit('input', filter[this.textField]);
        }
      },
      data: () => ({
        selected: null,
        selectItems: [],
        localValue: '',
        search:''
      })
    }
  </script>

<style>
.select-search .b-dropdown-form {
    padding: 0px 5px !important;
}

.select-search ul 
{
  width: 90% !important;
}

.select-search .dropdown-toggle, .select-search ul li button {
  width: 100% !important;
  text-overflow: ellipsis !important;
  overflow: hidden;
}
.back-orange { 
    background-color:orangered !important;
}
.select-search .back-orange button.dropdown-item{ 
    color: white !important;
}
</style>
  